<template>
  <div class="outer-box" >
    <h4>Disable SaaS Mode for all locations.</h4>

    <div class="inner-box" style="text-align: left; width: 600px;">
      <!-- <div>1. Disable SaaS Mode for a single Location:</div> -->
      <!-- <input class="form-control my-1" type="text" placeholder="Location ID" v-model="locationId" /> -->
      <b-alert show variant="danger">
        <b>Before disable SaaS, ask agency owner to do two things:</b>
        <br/>
        1. Reconcile the wallet balance with the location
        <br/>
        2. Cancel any saas subscriptions that might be running
        <br />
        3. <b>This step is irreversible</b>
        <br />
        4. Check above points for all the existing SaaS Locations.
      </b-alert>

      <input class="hl_input--wrap" type="text" placeholder="Company ID" v-model="companyId" />
      <p> ------ OR ------ </p>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Company Email ID"
        v-model="companyEmail"
      />
      <button class="btn btn-danger mt-4" @click="disableSaas">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Disable All</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService, SpmAppengineService } from "@/services";

export default {
  data() {
    return {
      companyId: '',
      companyEmail: '',
      processing: false,
      response: null
    };
  },
  methods: {
    async disableSaas(){
      this.processing = true
      if(!this.companyId) {
        try {
          let res = await SpmAppengineService.getCompanyIdFromCompanyEmail(this.companyEmail);
          this.response = res.data
          if(this.response.company_id) {
            this.companyId = this.response.company_id;
          }
        } catch (err) {
          this.response = err.message;
          this.processing = false;
          return;
        }
      }
      SaasService.disableSaasForCompany(this.companyId)
        .then(response => {
          this.response = response.data
        })
        .catch(error => {
          this.response = error.message
        })
        .finally(() => {
            this.processing = false;
        });
    },
  }
}
</script>

<style>
</style>
